import axios from 'axios'
import { baseURL } from '../store/constant'

const apiClient = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-type': 'application/json',
        // "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjEifQ.eyJpZCI6IjNVU00yblRxSzR3YTBtWlFhaDlhUCIsInR5cGUiOiJVU0VSIiwicHJvamVjdElkIjoiNENXRGRKRGRZTG00a3gwSVM4SGRhIiwiaWF0IjoxNjk5OTYwNjMyLCJleHAiOjE3MDA1NjU0MzIsImlzcyI6ImFjdGl2ZXBpZWNlcyJ9.f7x-QNUTiLFG2cEOn981OVK7VWYdjJyyQsoLxPsx_y0"
    }
})

apiClient.interceptors.request.use(function (config) {
    const token = localStorage.getItem('flow-token')

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

export default apiClient
